<template>
  <header class="section-header container-custom">
    <div class="section-header__menus">
      <div
          v-for="(item, index) in headerMenus"
          :key="index"
          class="menu"
          :class="{ active : item.active }"
      >
        <router-link
            v-if="!item.isCart"
            class="menu-item"
            :to="item.url"
            @click="handleChangeActive(index)"
        >
          {{ item.name }}
        </router-link>
        <div
            v-if="item.isCart"
            @click="handleViewBetSlip"
            class="menu-item-cart"
        >
          <img class="menu-cart" src="@/assets/images/home/cart.svg" />
          <span class="badge badge-light">{{ badgeNumber}}</span>
        </div>
      </div>
    </div>
    <ModalCommon
        v-if="showModalBetslip"
        @close="showModalBetslip = false"
        @login="handleLogin"
        @process-bet="handleProcessBet"
        @book-a-bet="handleBookABet"
        :isClassModalCustom="isModalCustomClass"
    >
      <YourBetslip
          v-bind:dataBetslip="listBetslips"
          v-bind:commonStake="commonStake"
          v-bind:totalStake="totalStake"
          :loading="loadingProcessBet"
          :loading-boot-a-bet="loadingBootABet"
          :is-disable-process-bet="isDisableProcessBet"
          :is-show-error-expired="isShowErrorExpired"
          :is-show-res-book-a-bet="isShowResBookABet"
          :booking-code-boot-a-bet="bookingCodeBootABet"
          @changeStake="handleChangeStake"
          @removeItemBetslip="handleRemoveItemBetslip"
          @removeAllBetslip="handleRemoveAllBetslips"
          @removeDrawsExpired="removeDrawsExpired"
          @moveToNextDraw="moveToNextDraw"
          @addClassModalClass="handleToggleClassModal"
      />
    </ModalCommon>
    <ModalCommon
        v-if="showModalProcessBet"
        @close="showModalProcessBet = false"
        @click-item="handleConfirmItem"
        @removeBetslip="listBetslips=[]"
    >
      <BetConfirmation />
    </ModalCommon>
    <ModalCommon
        v-if="showModalConfirmBet"
        @close="showModalConfirmBet = false"
        :refConfirm="refBetConfirmationDetail"
    >
      <BetConfirmationDetail />
    </ModalCommon>
  </header>
</template>
<script>
import { headerMenus } from '@/resources/header';
import ModalCommon from '@/components/common/modal/modal-common.vue';
import YourBetslip from "@/views/ticket/betslip/YourBetslip";
import BetConfirmation from "@/views/ticket/betslip/BetConfirmation";
import BetConfirmationDetail from "@/views/ticket/betslip/BetConfirmationDetail";
import YourBetslipMixin from "@/mixins/betslip/your-betslip-mixin";

export default {
  mixins: [YourBetslipMixin],
  components: {
    ModalCommon,
    YourBetslip,
    BetConfirmation,
    BetConfirmationDetail
  },
  data() {
    return {
      valueChecked: false,
      headerMenus
    }
  },
  computed: {
    badgeNumber () {
      return this.$store.state.badgeNumber
    }
  },
  mounted() {
    this.initBadgeNumber();
  },
  methods: {
    initBadgeNumber() {
      let yourBetslipStorage = localStorage.getItem('yourBetslip')
      if(yourBetslipStorage) {
        yourBetslipStorage = JSON.parse(yourBetslipStorage)
        this.$store.dispatch('changeBadgeNumber', yourBetslipStorage.length);
      }
    },
    handleChangeActive (index) {
      this.valueChecked = false;
      this.headerMenus.forEach((item, i) => {
        item.active = index === i;
      })
    }
  }
}
</script>
<style scoped lang="scss" src="@/assets/scss/_header.scss"/>
